module.exports = __webpack_public_path__ + "static/media/spinner.78103d91.png";